import React from 'react';
import { createPortal } from 'react-dom';
interface ElementSelectorOverlayProps {
  isSelecting: boolean;
  hoveredRect: DOMRect | null;
}
export function ElementSelectorOverlay({
  isSelecting,
  hoveredRect
}: ElementSelectorOverlayProps) {
  if (!isSelecting) return null;
  return createPortal(<div id="element-selector-overlay" className="fixed inset-0 z-[9999] pointer-events-none" data-id="element-154">
      {/* Dimmed Background */}
      <div className="absolute inset-0 bg-black/20 transition-opacity duration-300" data-id="element-155" />

      {/* Highlight Box */}
      {hoveredRect && <div className="absolute border-2 border-[#EC4899] bg-[#EC4899]/10 rounded-md transition-all duration-150 ease-out shadow-[0_0_15px_rgba(236,72,153,0.3)]" style={{
      top: hoveredRect.top,
      left: hoveredRect.left,
      width: hoveredRect.width,
      height: hoveredRect.height
    }} data-id="element-156">
          {/* Label Tag */}
          <div className="absolute -top-7 left-0 bg-[#EC4899] text-white text-[10px] font-bold px-2 py-1 rounded-t-md shadow-sm uppercase tracking-wider" data-id="element-157">
            Select Element
          </div>
        </div>}

      {/* Instruction Banner */}
      <div className="absolute top-8 left-1/2 -translate-x-1/2 bg-[#0F172A] border border-slate-700 text-white px-6 py-3 rounded-full shadow-2xl flex items-center gap-3" data-id="element-158">
        <div className="w-2 h-2 rounded-full bg-[#EC4899] animate-pulse" data-id="element-159" />
        <span className="text-sm font-medium" data-id="element-160">Selection Mode Active</span>
        <span className="text-xs text-slate-400 border-l border-slate-700 pl-3" data-id="element-161">
          Click any element to select • ESC to cancel
        </span>
      </div>
    </div>, document.body);
}